<template>
  <div id="app" :class="{'dark-mode': userDataStore.darkMode}">
    <transition mode="out-in" name="fade">
      <router-view/>
    </transition>
    <badge-catcher/>
  </div>
</template>

<script>
  import BadgeCatcher from './components/NotificationCatcher'
  export default {
    components: {BadgeCatcher},
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
    },
  }
</script>

<style lang="scss">
  @import 'src/styles/index';
</style>
